import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RewardShipmentsContent from "modules/RewardShipments";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const RewardShipmentsPage: React.FC = () => {
  setTitle("Reward Shipment");
  return (
    <Auth>
      <Layout>
        <RewardShipmentsContent />
      </Layout>
    </Auth>
  );
};

export default RewardShipmentsPage;
